import { render, staticRenderFns } from "./complaintListAL.vue?vue&type=template&id=0e034571&scoped=true"
import script from "./complaintListAL.vue?vue&type=script&lang=js"
export * from "./complaintListAL.vue?vue&type=script&lang=js"
import style0 from "./complaintListAL.vue?vue&type=style&index=0&id=0e034571&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e034571",
  null
  
)

export default component.exports